export default "__VITE_ASSET__l$r92SA4__"